import { __decorate } from "tslib";
import { NgModule, Optional, SkipSelf } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MapRoutingModule } from "./map-routing.module";
import { EsriMapComponent } from "./esri-map/esri-map.component";
import { FormsModule } from "@angular/forms";
import { DrawToolRemoveComponent } from "./shared/draw/draw-remove-all/draw-remove-all";
import { DrawBufferCheckboxComponent } from "./shared/draw/draw-buffer/draw-buffer-checkbox";
import { DrawBufferToolbarComponent } from "./shared/draw/draw-buffer/draw-buffer-toolbar";
import { MeasureComponent } from "./shared/measure/measure.component";
import { ExtentComponent } from "./shared/extent/extent.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
let MapModule = class MapModule {
    constructor(parentModule) {
        if (parentModule) {
            // TODO: Figure out how to do proper lazy loading
            /*throw new Error(
              "MapModule is a lazy loaded module, please only import in App module to ensure lazy loading works!");*/
        }
    }
    static ctorParameters = () => [
        { type: MapModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
    ];
};
MapModule = __decorate([
    NgModule({
        declarations: [
            EsriMapComponent,
            DrawBufferCheckboxComponent,
            DrawBufferToolbarComponent,
            DrawToolRemoveComponent,
            MeasureComponent,
            ExtentComponent
        ],
        exports: [
            EsriMapComponent,
            DrawBufferCheckboxComponent,
            DrawBufferToolbarComponent,
            DrawToolRemoveComponent,
            MeasureComponent,
            ExtentComponent,
        ],
        imports: [
            CommonModule,
            MapRoutingModule,
            FormsModule,
            MatProgressSpinnerModule,
        ]
    })
], MapModule);
export { MapModule };
